const toBoolean = value => value === 'true';

export { toBoolean };
